import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Chapters } from './components/Chapters';
import { PreviewCarousel } from './components/PreviewCarousel';
import { Reviews } from './components/Reviews';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Objections } from './components/Objections';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel Injection
    const pixelId = '1252242806993118';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
    return () => {
      // Cleanup if necessary, though usually fine to leave
    };
  }, []);
  return <div className="min-h-screen bg-[#f8f9fa] font-sans text-gray-900 selection:bg-[#84cc16] selection:text-[#1a3d1f]" data-id="element-0">
      <Hero data-id="element-1" />
      <Problems data-id="element-2" />
      <Chapters data-id="element-3" />
      <PreviewCarousel data-id="element-4" />
      <Reviews data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Offer data-id="element-7" />
      <Testimonials data-id="element-8" />
      <Objections data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}